import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { of, tap } from 'rxjs';

export const cache = new Map<string, any>();

export const utilsCacheInterceptor = (): HttpInterceptorFn => {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const { url, method } = req;

    if (method !== 'GET' || !url.includes('/utils/')) {
      return next(req);
    }
    const cachedResponse = cache.get(req.urlWithParams);
    if (cachedResponse) {
      // Serve from cache
      return of(cachedResponse);
    }
    return next(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // Cache the new response
          cache.set(req.urlWithParams, event);
        }
      })
    );
  };
};
